import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import LogoIcon from "@/components/LogoIcon";

export default function Footer() {
  return (
    <footer className="bg-[#fafbfc] mt-24 border-t border-[#f1f1f3]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-14">
        {/* Bottom grid: Logo/Description, Links & Contact info */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-5 flex flex-col items-center md:items-start text-center md:text-left">
            <div className="flex items-center gap-2 mb-4">
              <LogoIcon className="w-6 h-6" />
              <span className="font-quicksand text-xl font-extrabold">
                <span className="text-[#00d9a6]">Go</span>
                <span className="text-[#3d3d3d]">Protege</span>
              </span>
            </div>
            <p className="text-xs text-[#666] leading-relaxed max-w-md">
              Dispositivos para rastreamento veicular desde 2023 com nota fiscal, garantia e suporte técnico.
            </p>
          </div>

          <div className="md:col-span-3 md:pl-16 flex flex-col items-center md:items-start text-center md:text-left w-full">
            <div className="text-xs font-quicksand font-bold text-[#3d3d3d] mb-4 uppercase tracking-wider">LINKS ÚTEIS</div>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/rastrear" className="text-[#666] hover:text-[#1BB0CE] font-quicksand transition-colors">
                  Acompanhar Pedido
                </Link>
              </li>
              <li>
                <Link to="/politica/politica-privacidade" className="text-[#666] hover:text-[#1BB0CE] font-quicksand transition-colors">
                  Política de Privacidade
                </Link>
              </li>
              <li>
                <Link to="/politica/politica-reembolso" className="text-[#666] hover:text-[#1BB0CE] font-quicksand transition-colors">
                  Política de Reembolso
                </Link>
              </li>
              <li>
                <Link to="/politica/politica-devolucao" className="text-[#666] hover:text-[#1BB0CE] font-quicksand transition-colors">
                  Política de Devolução
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4 flex flex-col items-center md:items-start text-center md:text-left w-full">
            <div className="text-xs font-quicksand font-bold text-[#3d3d3d] mb-4 uppercase tracking-wider">ATENDIMENTO</div>
            <ul className="space-y-3 text-sm w-full">
              <li className="flex items-center justify-center md:justify-start gap-2 text-[#666]">
                <Phone className="w-4 h-4 text-[#1BB0CE]" />
                <span>
                  WhatsApp:{" "}
                  <a href="https://wa.me/15991927177" className="hover:text-[#1BB0CE] font-semibold transition-colors">
                    (15) 99192-7177
                  </a>
                </span>
              </li>
              <li className="flex items-center justify-center md:justify-start gap-2 text-[#666]">
                <Mail className="w-4 h-4 text-[#1BB0CE]" />
                <span>
                  E-mail:{" "}
                  <a href="mailto:loja@goprotege.com" className="hover:text-[#1BB0CE] font-semibold transition-colors">
                    loja@goprotege.com
                  </a>
                </span>
              </li>
              <li className="text-xs text-[#666] font-quicksand pt-1 text-center md:text-left">
                Segunda à Sexta das 08h às 18h.
              </li>
            </ul>
          </div>
        </div>

        {/* Footer legal & Asaas certificates */}
        <div className="mt-10 pt-6 border-t border-[#f1f1f3] flex flex-col items-center gap-4 text-xs text-[#999] text-center">
          <p className="font-quicksand">© {new Date().getFullYear()} GoProtege Rastreamento Veicular</p>
          <div className="flex items-center gap-3">
            <span className="font-quicksand">Pagamentos seguros via Asaas</span>
            <img 
              src="https://cdn-boto.asaas.com/_next/static/media/on-the-list.0lrtjc72jc-_i.svg" 
              alt="Asaas On The List" 
              className="h-5 object-contain"
            />
            <img 
              src="https://cdn-boto.asaas.com/_next/static/media/pci-dss.0n.uy89e9yf-i.svg" 
              alt="PCI DSS Compliant" 
              className="h-5 object-contain"
              style={{ filter: "brightness(0)" }}
            />
          </div>
        </div>
      </div>
    </footer>
  );
}
